import axios from 'axios'
import * as apiConstants from '../constants/api-constants'
import siteUrl from '../utils/siteUrl'
import userSessionStorage from '../utils/userSessionStorage'
import queryString from 'query-string'
import { secureStorage } from '../utils/utilities-secure-storage'
import { ERROR_MESSAGES } from '../constants/error-constants'

/**
 * ErrorEventEmitter class for handling API errors
 * @extends EventTarget
 */
class ErrorEventEmitter extends EventTarget {
	/**
	 * Emits an error event with the given error code or custom message
	 * @param {string} errorCode - The error code to look up in ERROR_MESSAGES
	 * @param {string} customMessage - Optional custom message to display
	 */
	emitError(errorCode, customMessage) {
		const message =
			ERROR_MESSAGES[errorCode] ||
			customMessage ||
			'Ha ocurrido un error inesperado'
		this.dispatchEvent(
			new CustomEvent('apiError', {
				detail: { message },
			})
		)
	}
}

export const errorEmitter = new ErrorEventEmitter()

export const axiosInstance = axios.create()
const session = new userSessionStorage()

//Get ip Address
const holderVariables = {}
async function getIp() {
  if (holderVariables.ip) {
    return holderVariables.ip
  }
  if (sessionStorage.getItem("ipAddress")) {
    holderVariables.ip = sessionStorage.getItem("ipAddress")
    return holderVariables.ip
  }
  holderVariables.ip = new Promise((resolve) => {
    axios
      .get(apiConstants.GET_IP_ADDRESS, { timeout: 5000 })
      .then(response => {
        sessionStorage.setItem("ipAddress", response.data.ip)
        resolve(response.data.ip)
      })
      .catch(() => {
        resolve('127.0.0.1')
      })
  })
  return holderVariables.ip
}

axiosInstance.interceptors.request.use(
	async config => {
		const tokenResponse = sessionStorage.getItem("ipAddress") ? sessionStorage.getItem("ipAddress") : await getIp();
    config.headers['Ip-Address'] = tokenResponse;
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// handle response error general case
axiosInstance.interceptors.response.use(
	response => {
		if (response?.data?.errorCode && ERROR_MESSAGES[response.data.errorCode]) {
			const errorMessage = ERROR_MESSAGES[response.data.errorCode]
			errorEmitter.emitError(response.data.errorCode)
			return Promise.reject(new Error(errorMessage))
		}
		return response
	},
	error => {
		const originalRequest = error.config
		// Error
		const {
			response: { status },
		} = error

		if (status === 401) {
			// Unauthorized request: maybe access token has expired!
			return refreshAccessToken(originalRequest)
		} else {
			return Promise.reject(error)
		}
	}
)

const refreshAccessToken = _originalRequest => {
	let userData = session.getUserInfo()
	_originalRequest._retry = true

	const payload = queryString.stringify({
		grant_type: 'refresh_token',
		client_id: apiConstants.CLIENT_ID,
		refresh_token: userData.tokens.refreshToken,
	})

	return axiosInstance
		.post(apiConstants.REFRESH_TOKEN, payload, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
			},
		})
		.then(response => {
			if (response.status === 200) {
				//Find and replace token data
				const currentTokenData = userData.tokens
				const newData = {
					...currentTokenData,
					accessToken: response.data.access_token,
					idToken: response.data.id_token,
				}

				userData.tokens = newData

				//Set new token data
				secureStorage.setItem('DATA', JSON.stringify(userData))

				// Replace token in original request
				_originalRequest.headers.Authorization = response.data.id_token
				return axios(_originalRequest)
			} else {
				secureStorage.removeItem('DATA')
				window.location.href = siteUrl
			}
		})
		.catch(err => {
			if (
				err.response.status === 400 &&
				err.response.data.error === 'invalid_grant'
			) {
				secureStorage.removeItem('DATA')
			} else {
				console.log(err)
			}
		})
}
